<template>
  <div>
    <a-row :gutter="8">
      <a-col :span="5">
        <a-card :bodyStyle="bodyStyle">
          <!-- 组织部门树组件 -->
          <OrganizationTree @selected="treeSelected" />
        </a-card>
      </a-col>
      <a-col :span="19">
        <a-card :bodyStyle="bodyStyle">
          <a-row>
            <!-- 查询条件区域 -->
            <queryInfo v-model="queryParam" />
          </a-row>
          <BaseTable ref="baseTable"
                     :table-setting="tableSetting"
                     :pageSetting="pageSetting"
                     @selectRow="selectRow"
                     @searchReset="searchReset"
                     :mainTable="mainTable"
                     :tableColumns="columns"
                     :tableData="tableData">
            <!-- 左侧操作按钮 -->
            <template #leftButton>
              <mtc-button class="mg-r8"
                          v-if="buttonSwitch.add"
                          @click="openActionModal(null, '0')"
                          type="primary"
                          icon="plus"
                          text="button.add" />
              <a-upload name="file"
                        :showUploadList="false"
                        :multiple="false"
                        :headers="tokenHeader"
                        :action="importExcelUrl"
                        @change="handleImportExcel">
                <mtc-button v-if="buttonSwitch.import" type="primary" class="mg-r8" icon="cloud-upload" text="button.import" />
              </a-upload>
               <mtc-button class="mg-r8"
                          v-if="buttonSwitch.download"
                          @click="templateDownload"
                          type="primary"
                          icon="cloud-download"
                          text="button.templateDownload" />
              <!-- 导出 -->
              <mtc-button v-if="buttonSwitch.export" :loading="exportLoading" @click="handleExportXls" type="primary" icon="download" text="button.export" />
            </template>
            <!-- 设备编号 -->
            <span slot="deviceName" slot-scope="{record}">
              <a @click="openDetail(record)">{{ record.deviceName }}</a>
            </span>
            <span slot="action" slot-scope="{record}">
              <!-- 编辑 -->
              <template v-if="buttonSwitch.update">
                <mtcLangPopover text="button.edit">
                  <a @click="openActionModal(record, '5')">编辑</a>
                </mtcLangPopover>
                <a-divider type="vertical" />
                </template>
              <!-- 更多 -->
              <a-dropdown>
                <a class="ant-dropdown-link">
                  <mtcLangPopover text="button.more" />
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <!-- 撤销 -->
                  <template v-if="buttonSwitch.cancel">
                  <!-- <template> -->
                    <a-menu-item>
                      <a-popconfirm title="确认撤销吗？" @confirm="cancelRecord(record)" placement="left">
                        撤销
                      </a-popconfirm>
                    </a-menu-item>
                  </template>
                  <!-- 运行 -->
                  <template v-if="buttonSwitch.recovery">
                    <a-menu-item v-if="checkButton(record, '4')">
                      <a-button type="link" @click="openActionModal(record, '4')">运行</a-button>
                    </a-menu-item>
                  </template>
                  <!-- 停运 -->
                  <template v-if="buttonSwitch.stop">
                    <a-menu-item v-if="checkButton(record, '1')">
                      <a-button type="link" @click="openActionModal(record, '1')">停运</a-button>
                    </a-menu-item>
                  </template>
                  <!--  更换 -->
                  <template v-if="buttonSwitch.change">
                    <a-menu-item v-if="checkButton(record, '2')">
                      <mtcLangPopover text="button.replace" @click="openActionModal(record, '2')" />
                    </a-menu-item>
                  </template>
                  <!--  移除 -->
                  <template v-if="buttonSwitch.remove">
                    <a-menu-item v-if="checkButton(record, '3')">
                      <mtcLangPopover text="button.remove" @click="openActionModal(record, '3')" />
                    </a-menu-item>
                  </template>
                  <!--  删除 -->
                  <!--  <a-menu-item>
                    <a-popconfirm :title="$t('tip.isDelete')" @confirm="handleDelete(record.id)" placement="left">
                      {{ $t('button.remove') }}
                    </a-popconfirm>
                  </a-menu-item>-->
                </a-menu>
              </a-dropdown>
            </span>
          </BaseTable>
        </a-card>
      </a-col>
    </a-row>
    <!-- 新增、禁用、更换模操作模态框 -->
    <actionModal ref="actionModal" @submit="submitModal" />
    <!-- 详情模态框 -->
    <detailModal ref="detailModal" />
  </div>
</template>

<script>
import OrganizationTree from '@comp/OrganizationTree/OrganizationTree'
import { BaseTable } from '@comp/mtcModule'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
import {
  efcOcnDeviceList,
  efcOcnDeviceRemove,
  efcOcnDeviceStop,
  efcOcnDeviceRecovery,
  efcOcnDeviceChange,
  efcOcnDeviceAdd,
  efcOcnDeviceUpload, templateDown, efcOcnDeviceCancel
} from '@api/online'
import pageConfig from './equipmentListConfig'
import actionModal from '@views/pages/equipmentList/components/actionModal'
import detailModal from '@views/pages/equipmentList/components/detailModal'
import queryInfo from '@views/pages/equipmentList/components/queryInfo'
import { efcOcnDeviceEdit } from '@api/online'
import { downFile, getAction } from '@api/manage'
import { filterObj } from '@/utils/util'

export default {
  name: 'equipmentList',
  title: '设备管理页面',
  components: { BaseTable, OrganizationTree, actionModal, detailModal, queryInfo },
  data() {
    return {
      code: 'ff808081840794cc018408fb9a670002',
      description: '设备管理',
      buttonSwitch: {
        add: true,
        update: true,
        delete: true,
        batch_delete: true,
        import: true,
        export: true,
        detail: true,
        super_query: true,
        bpm: true,
        // 撤销
        cancel: true,
        // 运行
        recovery: true,
        // 移除
        remove: true,
        // 停运
        stop: true,
        // 更换
        change: true,
        // 模板下载
        download: true
      },
      // 左侧树选择的节点
      orgTreeRelation: '',
      // 查询条件
      queryParam: {
        // 公司
        companyCode: '',
        // 海洋馆
        aquariumCode: '',
        // 场馆
        venueCode: '',
        // 缸体
        cylinderCode: ''
      },
      // 表名
      mainTable: 'efc_ocn_device_management',
      // 列表配置
      tableSetting: {
        height: window.innerHeight - 510
      },
      pageSetting: {
        pageSize: 10
      },
      tokenHeader: {
        'X-Access-Token': this.$ls.get(ACCESS_TOKEN),
        'tenant-id': this.$ls.get(TENANT_ID)
      },
      importExcelUrl: efcOcnDeviceUpload,
      bodyStyle: {
        height: `${window.innerHeight - 194}px`,
        overflowY: 'auto'
      },
      // 列表选中当前行数据
      currentRow: {},
      tableData: params => this.getTableData(params),
      columns: pageConfig.columns,
      // 根据操作类型调用提交方法
      submitFn: {
        // 新增
        '0': (data, callback) => this.handleAdd(data, callback),
        // 禁用
        '1': (data, callback) => this.handleStop(data, callback),
        // 更换
        '2': (data, callback) => this.handleReplace(data, callback),
        // 移除
        '3': (data, callback) => this.handleRemove(data, callback),
        // 启用
        '4': (data, callback) => this.handleEnable(data, callback),
        // 编辑
        '5': (data, callback) => this.editSave(data, callback)
      },
      exportLoading: false,
      selectedRowKeys: [],
    }
  },
  computed: {
    // 列表组件实例
    tableRef() {
      return this.$refs.baseTable
    }
  },
  created() {
    this.getButtonAuth()
  },
  methods: {
    selectRow(ids, rows) {
      this.selectedRowKeys = ids
    },
    handleExportXls() {
      //update--begin--autor:lvdandan-----date:20201110------for：LOWCOD-998 导出参数添加高级查询
      let param = this.queryParam
      //update--end--autor:lvdandan-----date:20201110------for：LOWCOD-998 导出参数添加高级查询
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param[ 'selections' ] = this.selectedRowKeys.join(',')
      }
      let paramsStr = JSON.stringify(filterObj(param))
      this.exportLoading = true
      let url = `/online/cgform/api/exportXls/${this.code}`
        downFile(url, { paramsStr: paramsStr }).then((data) => {
        if (!data || data.size === 0) {
          this.$message.warning(this.$t('tip.fileDownloadFailed'))
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data]), this.description + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', this.description + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      }).finally(e => this.exportLoading = false)
    },
    // 设备状态修改撤销
    cancelRecord(data) {
      let params = {
        id: data.id,
        recordDate: data.recordDate,
        runningStatus: data.runningStatus,
        status: data.status
      }
      efcOcnDeviceCancel(params).then(res => {
        this.$message.success(res.message)
        this.refresh()
      })
    },
    getButtonAuth() {
      let url = '/online/cgform/api/getColumns/'
      getAction(`${url}${this.code}`).then(res => {
        if (res.success) {
          this.initButtonSwitch(res.result.hideColumns)
        }
      })
    },
    initButtonSwitch(hideColumns) {
      Object.keys(this.buttonSwitch).forEach(key => {
        this.buttonSwitch[ key ] = true
      })
      if (hideColumns && hideColumns.length > 0) {
        Object.keys(this.buttonSwitch).forEach(key => {
          if (hideColumns.indexOf(key) >= 0) {
            this.buttonSwitch[ key ] = false
          }
        })
      }
    },
    // 列表数据接口
    getTableData(base) {
      let params = {
        ...base,
        ...this.queryParam
      }
      return efcOcnDeviceList(params)
    },
    // 重置查询条件
    searchReset() {
      this.queryParam = {}
      this.refresh()
    },
    // 刷新列表
    refresh() {
      this.tableRef.refresh()
    },
    // 判断按钮是否展示
    checkButton(data, type = '-1') {
      /* type
      * '0': '新增',
      * '1': '设备禁用',
      * '2': '设备更换',
      * '3': '设备移除',
      * '4': '设备启用'
      * '5': '编辑'
      * */
      // 状态移除时 没有操作
      if (data.status === pageConfig.deviceStatus.remove) return false
      // 运行状态时 操作：启用 停用 移除 更换
      if (data.status === pageConfig.deviceStatus.run) return true
      // if(data.status === '20') debugger
      // 状态停用时  操作：启用 变更 移除
      if (data.status === pageConfig.deviceStatus.off) {
        return ['2', '3', '4'].includes(type)
      }
      return true
    },
    // 选中左侧树进行查询
    treeSelected({ orgCategory, orgCode, orgTreeRelation }) {
      this.orgTreeRelation = orgTreeRelation
      // 根据节点类型转换获取查询字段
      let queryField = pageConfig.nodeTypeField[ orgCategory ]
      this.initQueryTree()
      this.queryParam[ queryField ] = orgCode
      this.refresh()
    },
    // 重置树节点相关的查询参数
    initQueryTree() {
      let temp = {
        // 公司
        companyCode: '',
        // 海洋馆
        aquariumCode: '',
        // 场馆
        venueCode: '',
        // 缸体
        cylinderCode: ''
      }
      this.queryParam = {
        ...this.queryParam,
        ...temp
      }
    },
    // 打开操作模态框
    openActionModal(data, type) {
      this.currentRow = data
      // 新增时如果左侧选择过，则赋值
      if (type === '0' && this.orgTreeRelation) {
        let arr = this.orgTreeRelation.split(',')
        data = {
          ...data,
          // 所属公司
          companyCode: arr[ 0 ] || '',
          // 所属海洋馆
          aquariumCode: arr[ 1 ] || '',
          // 所属场馆
          venueCode: arr[ 2 ] || '',
          // 所属缸体
          cylinderCode: arr[ 3 ] || ''
        }
      }
      this.$refs.actionModal.openModal(type, data)
    },
    // 模态框表单提交
    submitModal(data, type, callback) {
      this.submitFn[ type ](data, callback)
    },
    // 新增保存
    handleAdd(formData, callback) {
      efcOcnDeviceAdd(formData).then(res => {
        this.$message.success('操作成功')
        callback()
        this.refresh()
      })
    },
    // 编辑保存
    editSave(formData, callback) {
      let params = {
        id: this.currentRow.id,
        ...formData
      }
      efcOcnDeviceEdit(params).then(res => {
        this.$message.success('操作成功')
        callback()
        this.refresh()
      })
    },
    // 启用
    handleEnable(formData, callback) {
      let params = {
        id: this.currentRow.id,
        ...formData
      }
      this.checkRecordDate(params) && efcOcnDeviceRecovery(params).then(res => {
        this.$message.success('操作成功')
        callback()
        this.refresh()
      })
    },
    // 禁用
    handleStop(formData, callback) {
      let params = {
        id: this.currentRow.id,
        ...formData
      }
      this.checkRecordDate(params) && efcOcnDeviceStop(params).then(res => {
        this.$message.success('操作成功')
        callback()
        this.refresh()
      })
    },
    // 更换
    handleReplace(formData, callback) {
      let params = {
        id: this.currentRow.id,
        ...formData
      }
      this.checkRecordDate(params) && efcOcnDeviceChange(params).then(res => {
        this.$message.success('操作成功')
        callback()
        this.refresh()
      })
    },
    // 移除
    handleRemove(formData, callback) {
      let params = {
        id: this.currentRow.id,
        ...formData
      }
      this.checkRecordDate(params) && efcOcnDeviceRemove(params).then(res => {
        this.$message.success('操作成功')
        callback()
        this.refresh()
      })
    },
    // 校验业务日期
    checkRecordDate(params) {
      if (new Date(params.recordDate).getTime() >= new Date(this.currentRow.recordDate).getTime()) {
        return true
      } else {
        this.$message.warning('【业务日期】必须大于等于【状态变更日期】')
        return false
      }
    },
    // 打开详情模态框
    openDetail(data) {
      this.$refs.detailModal.openModal(data)
    },
    // 模板下载
    templateDownload() {
      // 排除字段
      let excludeColumns = ['status', 'old_status', 'create_by', 'create_time']
      window.open(templateDown(this.mainTable, excludeColumns))
    },
    // 文件上传
    handleImportExcel(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          if (info.file.response.code === 201) {
            let { message, result: { msg, fileUrl, fileName } } = info.file.response
            let href = window._CONFIG[ 'domianURL' ] + fileUrl
            this.$warning({
              title: message,
              content: (
                `<div>
                  <span>{msg}</span><br/>
                  <span>具体详情请 <a href={href} target="_blank" download={fileName}>点击下载</a> </span>
                </div>`
              )
            })
          } else {
            this.$message.success(info.file.response.message || `${info.file.name} 文件上传成功`)
          }
          this.refresh()
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`)
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`文件上传失败: ${info.file.msg} `)
      }
    }
  }
}
</script>